<h4 class="header">Import Summary</h4>
<div class="summary-section">
    <div class="summary-header">
        <div class="summary-header__item">
            <div class="summary-header__loadId">
                <div class="bold">LOAD ID: </div>
                <div class="summary-header__loadId" [title]="currentDataLoadId" (click)="copyLoadId()">
                    <div>{{ shortLoadId }}</div>
                    <app-icon iconStyle="far" iconName="copy"></app-icon>
                </div>
            </div>
        </div>
        <div class="summary-header__item">
            <span class="bold">PRODUCT TYPE: </span>
            <span>CHART LAKE</span>
        </div>
    </div>

    <div class="summary-body">
        <div class="summary-body__header">
            <div class="summary-body__type bold">TYPE</div>
            <div class="summary-body__details bold">DETAILS</div>
        </div>
        <div class="summary-body__content" [class.odd]="odd"
            *ngFor="let item of summaryReport; let odd = odd; trackBy: trackByIndex">
            <div class="summary-body__data">
                <div class="summary-body__type">
                    {{item.key}}
                </div>
                <div [ngClass]="getValidationMessageClass(item.value)" class="summary-body__details">
                    {{item.value}}
                </div>
            </div>
        </div>
    </div>

    <div class="summary-footer">
        <div *ngIf="canDownloadReport" class="text-right">
            <app-button classes="secondary" [disabled]="disableValidationReportBtn" class="summary-footer__button"
                text="Download Validation Report" (onClick)="onDownloadValidationReport()">
            </app-button>
        </div>
        <div *ngIf="canLoadMembers" class="text-right">
            <app-button classes="danger" class="summary-footer__button" text="Load Members" (onClick)="onLoadMembers()">
            </app-button>
        </div>

    </div>
</div>
<app-result-modal class="processing-modal" [(visible)]="isProcessingVisible" header="{{processHeaderText}}"
    [allowClose]="true">
    <div class="processing-modal__icon-spinner">
        <app-icon iconName="spinner" spin=true></app-icon>
    </div>
    <div class="processing-modal__message">This might take a few minutes</div>
</app-result-modal>